import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCog,
  faUserFriends,
  faBell,
  faUser,
  faChevronDown,
  faLock,
  faSignOutAlt,
  faBars,
  faSearch,
  faFilter,
  faTrash,
  faImages,
  faBox,
  faMinusSquare,
  faCheckSquare,
  faUserLock,
  faCopy,
  faCaretRight,
  faChevronRight,
  faChevronLeft,
  faFile,
  faWindowClose,
  faImage,
  faFilePdf,
  faShoppingCart,
  faUsers,
  faCheckCircle,
} from '@fortawesome/free-solid-svg-icons';
import { ReactComponent as ProductIcon } from './product-icon.svg';
import { ReactComponent as RechargeIcon } from './recharge-icon.svg';
import { ReactComponent as TransactionHistory } from './transaction-history.svg';
import { ReactComponent as AccountantIcon } from './accountant-icon.svg';
import { ReactComponent as CloudDownloadIcon } from './cloud-download-icon.svg';
import { ReactComponent as SuccessIcon } from './success-icon.svg';
import { ReactComponent as ErrorIcon } from './error-icon.svg';
import { ReactComponent as EditIcon } from './edit_icon.svg';
import { ReactComponent as AddCartIcon } from './add-cart-icon.svg';
import { ReactComponent as CopyCartIcon } from './copy-cart-icon.svg';
import { ReactComponent as ExportFileCartIcon } from './export-file-cart-icon.svg';
import { ReactComponent as EditCartIcon } from './edit-cart-icon.svg';
import { ReactComponent as HelpCircleIcon } from './help-circle-icon.svg';
import { ReactComponent as TrashFullCartIcon } from './trash-full-cart-icon.svg';
import { ReactComponent as AddProductCartIcon } from './add-product-cart-icon.svg';
import { ReactComponent as InfoCircleIcon } from './info-circle-icon.svg';
import { ReactComponent as CartIcon } from './cart-icon.svg';
import { ReactComponent as CloseIcon } from './close_small.svg';
import { ReactComponent as SortIcon } from './sort-icon.svg';
import { ReactComponent as PrinterIcon } from './printer.svg';
import { ReactComponent as HomeOutlineIcon } from './home-outline.svg';
import { ReactComponent as HomeFilledIcon } from './home-filled.svg';
import { ReactComponent as BellOutlineIcon } from './bell-outline.svg';
import { ReactComponent as BellFilledIcon } from './bell-filled.svg';
import { ReactComponent as ApplicationOutlineIcon } from './application-outline.svg';
import { ReactComponent as ApplicationFilledIcon } from './application-filled.svg';
import { ReactComponent as UserProfileOutlineIcon } from './user-profile-outline.svg';
import { ReactComponent as UserProfileFilledIcon } from './user-profile-filled.svg';

const Icon = {
  CustomIcon: FontAwesomeIcon,
  faCog,
  faUserFriends,
  faBell,
  faUser,
  faChevronDown,
  faLock,
  faSignOutAlt,
  faBars,
  faSearch,
  faFilter,
  faTrash,
  faImages,
  faBox,
  faMinusSquare,
  faCheckSquare,
  faUserLock,
  faCopy,
  faCaretRight,
  faChevronRight,
  faChevronLeft,
  faFile,
  faWindowClose,
  faImage,
  faFilePdf,
  faShoppingCart,
  faUsers,
  faCheckCircle,
};

const SvgIcon = {
  ProductIcon,
  RechargeIcon,
  TransactionHistory,
  AccountantIcon,
  CloudDownloadIcon,
  SuccessIcon,
  ErrorIcon,
  EditIcon,
  AddCartIcon,
  CopyCartIcon,
  ExportFileCartIcon,
  EditCartIcon,
  HelpCircleIcon,
  TrashFullCartIcon,
  AddProductCartIcon,
  InfoCircleIcon,
  CartIcon,
  CloseIcon,
  SortIcon,
  PrinterIcon,
  HomeOutlineIcon,
  HomeFilledIcon,
  BellOutlineIcon,
  BellFilledIcon,
  ApplicationOutlineIcon,
  ApplicationFilledIcon,
  UserProfileOutlineIcon,
  UserProfileFilledIcon,
};

export { FontAwesomeIcon, Icon, SvgIcon };
